import React from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

export default function ProtectedRoute({ component: Component, children }) {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0()
  const location = useLocation()

  if (isLoading) {
    return (
      <div style={{display:'grid', placeItems:'center', minHeight:'40vh'}}>
        <p>Loading your session…</p>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{color:'crimson'}}>
        Auth error: {String(error?.message || error)}
      </div>
    )
  }

  if (!isAuthenticated) {
    // Send to Auth0, then come back to this exact route
    loginWithRedirect({ appState: { returnTo: location.pathname + location.search } })
    return null
  }

  if (Component) {
    return <Component />
  }

  return <>{children}</>
}
